import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";
import type Stripe from "stripe";
import { BaseApiError } from "apis-v2/_sdk/types/errors";
import * as StripeUtils from "common/utils/stripeUtils";

const trackEvent = createTrackerForCategory(AmplitudeCategories.PaymentMethod);

enum events {
    VerificationFail = "VerificationFail",
    VerificationSuccess = "VerificationSuccess"
}

export async function VerificationFail({ workspaceId, error }: { workspaceId: string, error?: Error }) {
    let eventProperties = {
        workspace_id: workspaceId,
        error_type: "unknown",
        decline_code: "unknown",
        funding_type: "unknown",
        payment_type: "unknown"
    };

    if (error instanceof BaseApiError) {
        eventProperties = {
            ...eventProperties,
            error_type: error?.responseBody?.error_type ?? error.name ?? "unknown",
            decline_code: error?.responseBody?.decline_code ?? "unknown",
            funding_type: error?.responseBody?.funding_type ?? "unknown",
            payment_type: error?.responseBody?.payment_type ?? "unknown"
        };
    } else if (error?.name === "StripeRadarError") {
        const cause = (error as any)?.cause;
        eventProperties = {
            ...eventProperties,
            error_type: "StripeRadarError",
            decline_code: cause?.decline_code ?? "unknown",
            funding_type: StripeUtils.PaymentMethod.getFundingType(cause?.payment_method),
            payment_type: StripeUtils.PaymentMethod.getPaymentType(cause?.payment_method)
        };
    } else {
        eventProperties = {
            ...eventProperties,
            error_type: (error as any)?.type ?? "unknown",
            decline_code: (error as any)?.decline_code ?? "unknown"
        };
    }

    trackEvent(events.VerificationFail, eventProperties, { audit: true });
}

export async function VerificationSuccess({ paymentMethod, workspaceId }: { paymentMethod: Stripe.PaymentMethod, workspaceId: string }) {
    const eventProperties = {
        payment_type: StripeUtils.PaymentMethod.getPaymentType(paymentMethod),
        funding_type: StripeUtils.PaymentMethod.getFundingType(paymentMethod),
        workspace_id: workspaceId,
    };

    trackEvent(events.VerificationSuccess, eventProperties, { audit: true });
}
